<script lang="ts">
    import Search from '../../shared_components/Search.svelte';
    import Cart from '../../shared_components/Cart.svelte';
    import lang from '../../lang/language';
    import LanguageSelector from '../../shared_components/LanguageSelector.svelte';
    import WishlistInner from '../../shared_components/wishlist/WishlistInner.svelte';
    import ServicesAndMap from './ServicesAndMap.svelte';
    import StickyWishlist from '../../shared_components/wishlist/StickyWishlist.svelte';
    import Divider from '../../shared_components/Divider.svelte';
</script>

<div class="box">
    <Cart />
    <div class="breadcrumb">
        <div>
            <a href="https://yamatoji.nara-kankou.or.jp/">{lang.home}</a>
            <span class="separator">|</span>
            <span>{lang.list}</span>
        </div>
        <div>
            <LanguageSelector />
        </div>
    </div>
    <ServicesAndMap slot="col-1" />
</div>

<style>
    .display-type > div {
        padding: 10px 20px;
        border: 0px;
        color: #dba924;
        font-size: 1.1rem;
        transform: translateY(1px);
    }

    .display-type > div.active {
        background-color: #dba924;
        color: #ffffff;
        border: 2px solid #dba924;
        border-bottom: 0px;
    }
</style>
